import { CallStatusDefault } from '../../models';
import { State } from './model';

export const MaxTries = 3;

export const DelayBetweenTries = 5000;

export const StateDefault: State = {
  ...CallStatusDefault,
  updatedOn: undefined,
  tries: MaxTries,
};
